import React, { useContext, useEffect, useMemo, useState } from "react";
import Card from 'react-bootstrap/Card';
import { Container, Row, Col, Modal, Spinner, Form, InputGroup, FormControl, Button } from "react-bootstrap";
import { dataContext } from "components/dataContext/dataContext";
import DataTable from 'react-data-table-component';
import '../assets/css/dataTable.css'
import downloadCSV from '../csv/downloadCSV'
import { Input } from "reactstrap";
import { event } from "jquery";
import obj from "api/updateDevice";
import getDevice from "api/getDevice";
import getAnydesk from "api/getAnydesk";
import empresas from "api/empresas";
import { AccountContext } from "components/Account/Account";

function ListaEquipos() {
  const { data } = useContext(dataContext);
  const { getSession } = useContext(AccountContext);
  const [filtered, setFiltered] = useState([]);
  const [filter, setFilter] = useState('');
  const [dataFiltered, setDataFiltered] = useState(filtered);
  const [showEdit, setShowEdit] = useState(false)
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false)
  const [dispositivo, setDispositivo] = useState(false)
  const [dispositivoStatus, setDispositivoStatus] = useState('')
  const [deviceName, setDeviceName] = useState('');
  const [local, setLocal] = useState('');
  const [direccion, setDireccion] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [comuna, setComuna] = useState('');
  const [anydesk, setAnydesk] = useState('');
  const [password, setPassword] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [configGroups, setConfigGroups] = useState([]);
  const [deviceConfigGroupId, setDeviceConfigGroupId] = useState('');
  // const [showLoading, setShowLoading] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showAccess, setShowAccess] = useState(false);
  const [accessAnydesk, setAccessAnydesk] = useState('');
  const [accessPassword, setAccessPassword] = useState('');
  const [accessDeviceId, setAccessDeviceId] = useState('');
  const [accessDeviceName, setAccessDeviceName] = useState('');

  const [modalTitle, setModalTitleLoading] = useState('C2C BOLETAS CLOUD');
  const [message, setMessage] = useState('');

  useEffect(() => {
    try {
      if (data.estado) {
        console.log('Lista Equipos');

        const dataFilter = data.data.filter(e => e.empresa !== undefined).flatMap((e) => {
          let folios;
          try {
            folios = e.folios_disponibles[e.rut]?.[39];
            if (e.folios_disponibles[e.rut]?.[41] !== undefined) {
              folios = `${e.folios_disponibles[e.rut][39]} ; ${e.folios_disponibles[e.rut][41]}`;
            }
          } catch (error) {
            console.error(error);
          }
          return {
            rut: e.rut,
            device_id: e.device_id,
            device_name: e.device_name,
            dias: Math.trunc(e.dias),
            empresa: e.empresa,
            folios_disponibles: Math.trunc(folios),
            status: e.status,
            tenant_id : e.tenant_id,
            local: e.local || '',
            direccion: e.direccion || '',
            ciudad: e.ciudad || '',
            comuna: e.comuna || '',
            anydesk: e.anydesk || '',
            password: e.password || '',
            observaciones: e.observaciones || ''
          };
        });
        setFiltered(dataFilter);
        setDataFiltered(dataFilter);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  }, [data]);

  const handleChange = (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    const searchValue = e.target.value.toLowerCase();
    try {
      const aux = filtered.filter((element) => {
        const { rut, empresa, device_id, device_name, dias, folios_disponibles } = element;
        return (
          (rut && rut.trim().includes(searchValue)) ||
          (empresa && empresa.toLowerCase().trim().includes(searchValue)) ||
          (device_id && device_id.toLowerCase().trim().includes(searchValue)) ||
          (device_name && device_name.toLowerCase().trim().includes(searchValue)) ||
          (typeof dias === 'number' && dias.toString().includes(searchValue)) ||
          (typeof folios_disponibles === 'number' && folios_disponibles.toString().includes(searchValue))
        );
      });
      setDataFiltered(aux);
      ;
      if (aux.length === 0) {
        // setShowLoading(true);
        // setModalTitleLoading('C2C BOLETAS CLOUD');
        // setLoadingMessage('No se encontraron resultados para filtrar');
      }
    } catch (error) {
      // setShowErrorModal(true);
      // setErrorMessage('Ocurrió un error al filtrar los datos: ' + error.message);
    }
  };

  const editardispositivo = async (row) => {
    setShowLoadingModal(true);
    setLoadingModal(true);
    setMessage('');

    try {
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      const [deviceResp, groupsResp] = await Promise.all([
        getDevice(idToken, row.tenant_id, row.device_id),
        empresas.getDeviceConfigGroups(row.tenant_id, idToken),
      ]);
      const deviceData = deviceResp?.data?.data || deviceResp?.data || {};
      const groupsData = Array.isArray(groupsResp?.data)
        ? groupsResp.data
        : (groupsResp?.data?.items || []);

      const dispositivoInfo = {
        rut: row.rut,
        empresa: row.empresa,
        device_id: row.device_id,
        device_name: deviceData.device_name ?? row.device_name,
        dias: Math.trunc(row.dias),
        status: deviceData.status ?? row.status,
        folios_disponibles: row.folios_disponibles,
        tenant_id: row.tenant_id,
        local: deviceData.local ?? '',
        direccion: deviceData.direccion ?? '',
        ciudad: deviceData.ciudad ?? '',
        comuna: deviceData.comuna ?? '',
        anydesk: deviceData.anydesk ?? '',
        password: deviceData.password ?? '',
        observaciones: deviceData.observaciones ?? '',
        deviceconfiggroup_id: deviceData.deviceconfiggroup_id ?? ''
      };

      setDispositivo(dispositivoInfo);
      setDispositivoStatus(dispositivoInfo.status);
      setDeviceName(dispositivoInfo.device_name);
      setLocal(dispositivoInfo.local);
      setDireccion(dispositivoInfo.direccion);
      setCiudad(dispositivoInfo.ciudad);
      setComuna(dispositivoInfo.comuna);
      setAnydesk(dispositivoInfo.anydesk);
      setPassword(dispositivoInfo.password);
      setObservaciones(dispositivoInfo.observaciones);
      setConfigGroups(groupsData);
      setDeviceConfigGroupId(dispositivoInfo.deviceconfiggroup_id);

      setLoadingModal(false);
      setShowLoadingModal(false);
      setShowEdit(true);
    } catch (error) {
      console.error('Error al obtener el dispositivo:', error);
      setLoadingModal(false);
      setMessage('Error al obtener la información del dispositivo. Por favor, inténtelo de nuevo.');
    }
  }




  const verAcceso = async (row) => {
    setShowLoadingModal(true);
    setLoadingModal(true);
    setMessage('');

    try {
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      const response = await getAnydesk(idToken, row.tenant_id, row.device_id);
      const deviceData = response?.data?.data || response?.data || {};

      setAccessDeviceId(row.device_id);
      setAccessDeviceName(deviceData.device_name ?? row.device_name ?? '');
      setAccessAnydesk(deviceData.anydesk ?? row.anydesk ?? '');
      setAccessPassword(deviceData.password ?? row.password ?? '');

      setLoadingModal(false);
      setShowLoadingModal(false);
      setShowAccess(true);
    } catch (error) {
      console.error('Error al obtener el dispositivo:', error);
      setLoadingModal(false);
      setMessage('Error al obtener la información del dispositivo. Por favor, inténtelo de nuevo.');
    }
  }

  const validarCampos = () => {
    if (!deviceName || !deviceName.trim()) {
      return 'El nombre del dispositivo es obligatorio.';
    }
    if (!deviceConfigGroupId) {
      return 'Debe seleccionar un grupo de configuración.';
    }
    if (deviceName.length > 100) {
      return 'El nombre del dispositivo no puede superar los 100 caracteres.';
    }
    if (local.length > 100) {
      return 'El campo Local no puede superar los 100 caracteres.';
    }
    if (direccion.length > 70) {
      return 'El campo Dirección no puede superar los 70 caracteres.';
    }
    if (ciudad.length > 20) {
      return 'El campo Ciudad no puede superar los 20 caracteres.';
    }
    if (comuna.length > 20) {
      return 'El campo Comuna no puede superar los 20 caracteres.';
    }
    if (observaciones.length > 150) {
      return 'El campo Observaciones no puede superar los 150 caracteres.';
    }
    return null;
  }

  const guardarCambios = async (event) => {
    event.preventDefault();

    const errorValidacion = validarCampos();
    if (errorValidacion) {
      setShowEdit(false);
      setShowLoadingModal(true);
      setLoadingModal(false);
      setMessage(errorValidacion);
      return;
    }

    const dispositivoActualizado = {
      ...dispositivo,
      device_name: deviceName,
      status: dispositivoStatus, // Actualiza el estado del dispositivo
      local,
      direccion,
      ciudad,
      comuna,
      anydesk,
      password,
      observaciones,
      deviceconfiggroup_id: deviceConfigGroupId
    };
    console.log('Dispositivo actualizado:', dispositivoActualizado);

    //llamado a api para guardar cambios
    try {
      setShowEdit(false);
      setShowLoadingModal(true);
      setLoadingModal(true);
  
      const idToken = await getSession().then((session) => session.idToken.jwtToken);
      await obj.updateDevice(idToken, dispositivoActualizado);
      console.log('Dispositivo guardado en la API');
      setMessage('Dispositivo actualizado exitosamente.');
     
      const updatedDataFiltered = dataFiltered.map((item) =>
        item.device_id === dispositivoActualizado.device_id ? dispositivoActualizado : item
      );
      setDataFiltered(updatedDataFiltered);

    } catch (error) {
      console.error('Error al guardar el dispositivo:', error);
      setMessage('Error al actualizar el dispositivo. Por favor, inténtelo de nuevo.');


    }
    finally {
    
      setLoadingModal(false);
      
    }
  }

  useEffect(() => {
    const stateValues = ['dataFiltered', 'filter'];
    stateValues.forEach((state) => {
      // console.log(`RR useEffect ${state}:`, eval(state));
    });
  }, [dataFiltered, filter]);

  const columns = [
    {
      name: 'Rut',
      selector: row => row.rut,
      sortable: true,
      width: '8%',
    },
    {
      name: 'Cliente',
      selector: row => row.empresa,
      sortable: true,
    },
    {
      name: 'ID Dispositivo',
      selector: row => row.device_id,
      sortable: true,
    },
    {
      name: 'Nombre Dispositivo',
      selector: row => row.device_name,
      sortable: true,
    },
    {
      name: 'Última Conexión',
      selector: row => Math.trunc(row.dias),
      sortable: true,
      width: '12%',
    },
    {
      name: 'Folios Disponibles',
      selector: row => row.folios_disponibles,
      sortable: true,
      width: '12%',
    },
    {
      name: 'Estado',
      selector: row => { return (<span>{row.status === 'active' ? 'Activo' : row.status === 'disabled' ? 'Inactivo' : 'Suspendido'}</span>) },
      sortable: true,
      width: '12%',
    },
    {
      name: "Acciones",
      cell: (row) => {

        return (
          <div className="d-flex gap-1">
            <Button
              size="sm"
              variant="warning"
              onClick={() => editardispositivo(row)}
            >
              Editar
            </Button>
            <Button
              size="sm"
              variant="info"
              onClick={() => verAcceso(row)}
            >
              Acceso
            </Button>
          </div>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '180px',

    },
  ];

  const paginationOpciones = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsText: 'Todos'
  }

  const Export = ({ onExport }) => <Button onClick={e => onExport(e.target.value)}>Exportar</Button>;
  const actionsMemo = useMemo(() => <Export onExport={() => downloadCSV(dataFiltered)} />, [dataFiltered]);

  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <Card className="strpied-tabled-with-hover">
            <Card.Header>
              <Card.Title as="h4">Lista de Equipos C2C</Card.Title>
              <p className="card-category">
                Última Actualización: {data.lastcheck}
              </p>
            </Card.Header>
            <Card.Body className="table-full-width table-responsive px-0">
              <Input name="search" value={filter} autoComplete="off" placeholder="Filtrar" className="mb-3" onChange={handleChange} />
              <DataTable
                className="-striped -highlight"
                fixedHeader={true}
                columns={columns}
                data={dataFiltered}
                pagination
                progressPending={loading}
                paginationComponentOptions={paginationOpciones}
                actions={actionsMemo}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal show={showEdit} onHide={() => setShowEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar dispositivo</Modal.Title>
        </Modal.Header>

        <Modal.Body>


          {!loading && dispositivo && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Empresa</Form.Label>
                <Form.Control value={dispositivo.empresa} disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>ID Dispositivo</Form.Label>
                <Form.Control value={dispositivo.device_id} disabled />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  value={deviceName}
                  onChange={(e) => setDeviceName(e.target.value)
                  }
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Estado</Form.Label>
                <Form.Control as="select"
                  value={dispositivoStatus}
                  onChange={(e) =>
                    setDispositivoStatus(e.target.value)
                  }
                >
                  <option value="active">Activo</option>
                  <option value="disabled">Inactivo</option>
                  <option value="suspended">Suspendido</option>
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Local</Form.Label>
                <Form.Control
                  value={local}
                  maxLength={100}
                  onChange={(e) => setLocal(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Dirección</Form.Label>
                <Form.Control
                  value={direccion}
                  maxLength={70}
                  onChange={(e) => setDireccion(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Ciudad</Form.Label>
                <Form.Control
                  value={ciudad}
                  maxLength={20}
                  onChange={(e) => setCiudad(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Comuna</Form.Label>
                <Form.Control
                  value={comuna}
                  maxLength={20}
                  onChange={(e) => setComuna(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>AnyDesk</Form.Label>
                <Form.Control
                  value={anydesk}
                  onChange={(e) => setAnydesk(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Grupo de configuración</Form.Label>
                <Form.Control
                  as="select"
                  value={deviceConfigGroupId || ''}
                  onChange={(e) => setDeviceConfigGroupId(e.target.value)}
                >
                  <option value="" disabled>Seleccione un grupo</option>
                  {configGroups.map((g) => (
                    <option key={g.deviceconfiggroup_id} value={g.deviceconfiggroup_id}>
                      {g.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Observaciones</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={observaciones}
                  maxLength={150}
                  onChange={(e) => setObservaciones(e.target.value)}
                />
              </Form.Group>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEdit(false)}>
            Cerrar
          </Button>
          <Button variant="success" onClick={guardarCambios}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={showAccess} onHide={() => setShowAccess(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Acceso del dispositivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>ID Dispositivo</Form.Label>
            <Form.Control value={accessDeviceId} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Nombre Dispositivo</Form.Label>
            <Form.Control value={accessDeviceName} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>AnyDesk</Form.Label>
            <InputGroup>
              <Form.Control value={accessAnydesk} readOnly />
              <Button
                variant="outline-secondary"
                onClick={() => navigator.clipboard.writeText(accessAnydesk)}
                disabled={!accessAnydesk}
              >
                Copiar
              </Button>
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <InputGroup>
              <Form.Control value={accessPassword} readOnly />
              <Button
                variant="outline-secondary"
                onClick={() => navigator.clipboard.writeText(accessPassword)}
                disabled={!accessPassword}
              >
                Copiar
              </Button>
            </InputGroup>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAccess(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showLoadingModal} onHide={() => setShowLoadingModal(false)}>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingModal && <Spinner animation="border" role="status" className='sticky-top'></Spinner>}
          <p>{!loadingModal && <> {message} </>}</p>


        </Modal.Body>
        <Modal.Footer>
          {!loadingModal &&
            <Button variant="secondary" onClick={() => setShowLoadingModal(false)}>
              Cerrar
            </Button>
          }

        </Modal.Footer>
      </Modal>

    </Container>
  );
}

export default ListaEquipos;
